<template lang="pug">
#content.snap-content
  .overlay(@click="hide()")
  Marquee(:class="{ 'd-none': !whiteLabel }")
  toolBar
  .content-center
    .pagepanel
      .page-group
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-general")
          .betting-rules-item.mt-2
            span {{ $t("ui.general_betting_rules") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-general-market")
          .betting-rules-item.mt-2
            span {{ $t("ui.general_rules_market") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-soccer")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/1.svg?v=12')
            span {{ $t("ui.soccer") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-basketball")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/2.svg?v=12')
            span {{ $t("ui.basketball") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-tennis")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/7.svg?v=12')
            span {{ $t("ui.tennis") }}
        //- router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-esports")
        //-   .betting-rules-item.mt-2
        //-     img.icon(src='/images/icon-sport-svg/20.svg?v=12')
        //-     span {{ $t("ui.esports") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-baseball")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/8.svg?v=12')
            span {{ $t("ui.baseball") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-american-football")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/6.svg?v=12')
            span {{ $t("ui.american_football") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-athletics")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/34.svg?v=12')
            span {{ $t("ui.athletics") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-aussie-rules-football")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/25.svg?v=12')
            span {{ $t("ui.aussie_rules_football") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-badminton")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/3.svg?v=12')
            span {{ $t("ui.badminton") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-bandy")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/23.svg?v=12')
            span {{ $t("ui.bandy") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-beach-soccer")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/17.svg?v=12')
            span {{ $t("ui.beach_soccer") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-boxing")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/19.svg?v=12')
            span {{ $t("ui.boxing") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-cricket")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/12.svg?v=12')
            span {{ $t("ui.cricket") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-cycling")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/31.svg?v=12')
            span {{ $t("ui.cycling") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-darts")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/16.svg?v=12')
            span {{ $t("ui.darts") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-field-hockey")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/30.svg?v=12')
            span {{ $t("ui.field_hockey") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-futsal")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/1.svg?v=12')
            span {{ $t("ui.futsal") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-gaelic-football")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/27.svg?v=12')
            span {{ $t("ui.gaelic_football") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-golf")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/10.svg?v=12')
            span {{ $t("ui.golf") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-handball")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/18.svg?v=12')
            span {{ $t("ui.handball") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-hurling")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/26.svg?v=12')
            span {{ $t("ui.hurling") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-ice-hockey")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/9.svg?v=12')
            span {{ $t("ui.ice_hockey") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-kabbadi")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/39.svg?v=12')
            span {{ $t("ui.kabbadi") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-mma")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/35.svg?v=12')
            span {{ $t("ui.mma") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-motorsports")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/14.svg?v=12')
            span {{ $t("ui.motorsports") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-muay-thai")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/15.svg?v=12')
            span {{ $t("ui.muay_thai") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-netball")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/37.svg?v=12')
            span {{ $t("ui.netball") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-rugby")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/13.svg?v=12')
            span {{ $t("ui.rugby") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-sepak-takraw")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/38.svg?v=12')
            span {{ $t("ui.sepak_takraw") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-snooker")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/5.svg?v=12')
            span {{ $t("ui.snooker") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-squash")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/21.svg?v=12')
            span {{ $t("ui.squash") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-table-tennis")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/4.svg?v=12')
            span {{ $t("ui.table_tennis") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-volleyball")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/11.svg?v=12')
            span {{ $t("ui.volleyball") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-water-polo")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/28.svg?v=12')
            span {{ $t("ui.water_polo") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-winter-sports")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/29.svg?v=12')
            span {{ $t("ui.winter_sports") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-4d-special")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/40.svg?v=12')
            span {{ $t("ui.fd") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-kof")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/43.svg?v=12')
            span {{ $t("ui.kof") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-sfv")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/42.png?v=12')
            span {{ $t("ui.sfv") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-ufc")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/43.svg?v=12')
            span {{ $t("ui.ufc") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-vgames")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-other/v-games.svg?v=12')
            span V-GAMES
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-archery")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/24.svg?v=12')
            span {{ $t("ui.archery") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-olympic")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/36.svg?v=12')
            span {{ $t("ui.olympic") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-winter-olympic")
          .betting-rules-item.mt-2
            img.icon(src='/images/icon-sport-svg/38.svg?v=12')
            span {{ $t("ui.winter_olympic") }}
        router-link(href="javascript:void(0);" to="/mobile/rules/page-betting-rules-slots")
          .betting-rules-item.mt-2
            span {{ $t("ui.slots_rules") }}
  footerNav
</template>


<script>
import toolBar from "@/components/mobile/toolBar";
import footerNav from "@/components/mobile/footerNav";
import Marquee from "@/components/mobile/mainPanelControl/marquee";
import config from "@/config";

export default {
  components: {
    toolBar,
    footerNav,
    Marquee
  },
  computed: {
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  methods: {
    hide(e) {
      var body = $("body");
      if (body.hasClass("snapjs-left")) {
        body.removeClass("snapjs-left");
      }
    }
  }
};
</script>
